import React from "react";
import { Copy } from "lucide-react";
import { toast } from "sonner";

export const BANK_METHODS = ["bca", "mandiri", "bni", "bri"];
export const PAYMENT_LABELS = { bca: "Transfer BCA", mandiri: "Transfer Mandiri", bni: "Transfer BNI", bri: "Transfer BRI", qris: "QRIS", midtrans: "Pembayaran Online (Midtrans)" };

// Sumber utama: `order.manual_payment_details` (backend, tenant-safe, pencocokan label bank toleran).
// Fallback legacy (response lama tanpa field itu): exact-match client-side terhadap /settings.bank_accounts.
export function resolveBankAccount(order, settings) {
  const details = order?.manual_payment_details;
  if (details && details.method !== "qris") {
    return details.configured
      ? { bank: details.bank_name, account_number: details.account_number, account_name: details.account_name }
      : null;
  }
  return settings?.bank_accounts?.find((b) => b.bank?.toLowerCase() === order?.payment_method) || null;
}

export async function copyText(value, label) {
  if (!value) return;
  try {
    await navigator.clipboard.writeText(value);
    toast.success(`${label} "${value}" disalin`);
  } catch {
    toast.error(`Tidak dapat menyalin. Salin manual ${label.toLowerCase()} di atas.`);
  }
}

export function BankTransferInstruction({ order, settings }) {
  const method = order?.payment_method;
  if (!BANK_METHODS.includes(method)) return null;
  const acct = resolveBankAccount(order, settings);
  if (!acct) {
    return (
      <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-3 mb-3 text-sm text-yellow-800" data-testid="bank-account-missing">
        Nomor rekening untuk {PAYMENT_LABELS[method]} belum tersedia dari toko. Silakan hubungi toko via WhatsApp untuk informasi rekening sebelum transfer.
      </div>
    );
  }
  return (
    <div className="system-soft-bg rounded-xl p-3 mb-3" data-testid="bank-account-display">
      <div className="text-xs text-[#5C5C5C]">Transfer ke:</div>
      <div className="grid gap-1 mt-1 text-sm">
        <div className="flex flex-wrap items-baseline gap-x-2">
          <span className="text-xs text-[#5C5C5C] w-24 shrink-0">Bank</span>
          <span className="font-display font-bold text-lg" data-testid="bank-account-bank">{acct.bank}</span>
        </div>
        <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
          <span className="text-xs text-[#5C5C5C] w-24 shrink-0">No. Rekening</span>
          <span className="font-mono font-bold text-lg tracking-wider break-all" data-testid="bank-account-number">{acct.account_number}</span>
          <button
            type="button"
            onClick={() => copyText(acct.account_number, "Nomor rekening")}
            className="inline-flex items-center gap-1 text-xs px-2 py-1 rounded-lg border border-[#E5E5E5] hover:bg-white"
            aria-label="Salin nomor rekening"
            data-testid="bank-account-copy"
          >
            <Copy size={12} /> Salin
          </button>
        </div>
        <div className="flex flex-wrap items-baseline gap-x-2">
          <span className="text-xs text-[#5C5C5C] w-24 shrink-0">Atas Nama</span>
          <span className="font-semibold" data-testid="bank-account-name">{acct.account_name || "-"}</span>
        </div>
      </div>
    </div>
  );
}
